module.exports = { buildings: [
  {
    "id": "way/112574117",
    "title": "Academic House",
    "campus": "Main",
    "popup": {
      "title": "Academic House",
      "content": null,
      "directions": {
        "lat": "41.65759202203046",
        "lng": " -83.61791862738936"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": []
    }
  },
  {
    "id": "relation/8829571",
    "title": "Koester Alumni Pavilion",
    "campus": "Main",
    "hidden": true,
    "popup": {
      "title": "Koester Alumni Pavilion",
      "content": null,
      "directions": {
        "lat": "41.657763726943706",
        "lng": " -83.61505202930793"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": []
    }
  },
  {
    "id": "way/313487066",
    "title": "Bowman Oddy",
    "campus": "Main",
    "popup": null
  },
  {
    "id": "way/431588207",
    "title": "Center for Administrative Support",
    "campus": "Main",
    "hidden": true,
    "popup": null
  },
  {
    "id": "way/635516323",
    "title": "Carlson Library",
    "campus": "Main",
    "popup": {
      "title": "Carlson Library",
      "content": "The [Carlson Library](https://www.utoledo.edu/library/index.html) was named for UToledo’s longest serving president, Dr. William S. Carlson. The six levels of the library contain more than 24 miles of shelving, more than 1.5 million bound volumes of journals and 2,800 study carrels.\n",
      "directions": {
        "lat": "41.65993065833668",
        "lng": " -83.61514802866758"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": [
        {
          "id": "rectXezQD6nLNFUQM",
          "name": "scene_toledo_library",
          "title": "Carlson Library"
        }
      ]
    }
  },
  {
    "id": "way/439090156",
    "title": "Fetterman Training Center",
    "campus": "Main",
    "hidden": true,
    "popup": null
  },
  {
    "id": "way/227496351",
    "title": "Memorial Field House",
    "campus": "Main",
    "popup": {
      "title": "Memorial Field House",
      "content": "\n",
      "directions": {
        "lat": "41.66119622761295",
        "lng": " -83.61619835817022"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": [
        {
          "id": "recbEf4g66x9lWP2y",
          "name": "scene_toledo_field_house_lobby",
          "title": "Memorial Field House Lobby"
        }
      ]
    }
  },
  {
    "id": "way/654951720",
    "title": "Glass Bowl Stadium",
    "campus": "Main",
    "popup": {
      "title": "Glass Bowl Stadium",
      "content": "\n",
      "directions": {
        "lat": "41.65726571099802",
        "lng": " -83.6135923296253"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": [
        {
          "id": "recqHVmOaPUoXdurs",
          "name": "scene_toledo_glass_bowl",
          "title": "Glass Bowl"
        }
      ]
    }
  },
  {
    "id": "way/431588235",
    "title": "Grounds & Fleet Services",
    "campus": "Main",
    "hidden": true,
    "popup": null
  },
  {
    "id": "way/227496349",
    "title": "Gillham Hall",
    "campus": "Main",
    "popup": {
      "title": "Gillham Hall",
      "content": "\n",
      "directions": {
        "lat": "41.66227434277838",
        "lng": " -83.61305422898492"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": [
        {
          "id": "recJmpOu41SS7Auqq",
          "name": "scene_toledo_study_area",
          "title": "Carver Center in Gilham Hall"
        }
      ]
    }
  },
  {
    "id": "way/112574110",
    "title": "Health Education Center",
    "campus": "Main",
    "popup": {
      "title": "Health Education Center",
      "content": null,
      "directions": {
        "lat": "41.65826571101049",
        "lng": " -83.61200000076113"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": []
    }
  },
  {
    "id": "way/227500080",
    "title": "Health & Human Services",
    "campus": "Main",
    "popup": {
      "title": "Health & Human Services",
      "content": "\n",
      "directions": null,
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": [
        {
          "id": "recFQzFLiVkBodUmI",
          "name": "scene_toledo_courtroom_mock_trial",
          "title": "McQuade Courtroom"
        },
        {
          "id": "recK54nBYSrfqBrho",
          "name": "scene_toledo_heath_class",
          "title": "Respiratory Therapy Lab"
        }
      ]
    }
  },
  {
    "id": "way/443009982",
    "title": "Honors Academic Village",
    "campus": "Main",
    "popup": {
      "title": "Honors Academic Village",
      "content": null,
      "directions": {
        "lat": "41.661873623943016",
        "lng": " -83.6183688154291"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": []
    }
  },
  {
    "id": "way/112574106",
    "title": "Horton International House",
    "campus": "Main",
    "popup": {
      "title": "Horton International House",
      "content": null,
      "directions": {
        "lat": "41.65682126574067",
        "lng": " -83.61850816232192"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": []
    }
  },
  {
    "id": "way/313486417",
    "title": "Law Center",
    "campus": "Main",
    "popup": {
      "title": "Law Center",
      "content": "The Law Center houses UToledo’s [College of Law](https://www.utoledo.edu/law/index.html). Completed in 1972 and expanded in 1981, the Center includes lecture halls, faculty offices and the Moot Mock Trial Classroom.\n\n",
      "directions": {
        "lat": "41.658491474644755",
        "lng": " -83.62012580891182"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": [
        {
          "id": "reciwClsHjwcHiEd0",
          "name": "scene_toledo_courtroom",
          "title": "College of Law Courtroom"
        }
      ]
    }
  },
  {
    "id": "way/227540927",
    "title": "Libbey Hall",
    "campus": "Main",
    "popup": {
      "title": "Libbey Hall",
      "content": "\n",
      "directions": {
        "lat": "41.661974198032425",
        "lng": " -83.61640087915639"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": [
        {
          "id": "recEfkL4TDpl1jjxq",
          "name": "scene_toledo_libbey_hall_exterior",
          "title": "Libbey Hall"
        }
      ]
    }
  },
  {
    "id": "way/431585321",
    "title": "Larimer Athletic Complex",
    "campus": "Main",
    "popup": {
      "title": "Larimer Athletic Complex",
      "content": null,
      "directions": {
        "lat": "41.65817372432577",
        "lng": " -83.61330222423783"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": []
    }
  },
  {
    "id": "way/197291059",
    "title": "McMaster Hall",
    "campus": "Main",
    "popup": {
      "title": "McMaster Hall",
      "content": null,
      "directions": {
        "lat": "41.66232562643008",
        "lng": " -83.61152114253898"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": []
    }
  },
  {
    "id": "way/443006954",
    "title": "MacKinnon Hall",
    "campus": "Main",
    "popup": {
      "title": "MacKinnon Hall",
      "content": null,
      "directions": {
        "lat": "41.661536343358485",
        "lng": " -83.61711876366189"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": []
    }
  },
  {
    "id": "way/423039653",
    "title": "Nitschke Auditorium",
    "campus": "Main",
    "popup": {
      "title": "Nitschke Auditorium",
      "content": null,
      "directions": {
        "lat": "41.65509864945478",
        "lng": " -83.6063649536475"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": []
    }
  },
  {
    "id": "relation/6898022",
    "title": "Engineering Complex",
    "campus": "Main",
    "popup": {
      "title": "Engineering Complex",
      "content": "The Engineering Complex is the home of UToledo’s [College of Engineering](https://www.utoledo.edu/engineering/index.html), one of the premiere engineering schools in Ohio.\n",
      "directions": {
        "lat": "41.655546123640505",
        "lng": " -83.606140948348"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": [
        {
          "id": "recnZXBVta9XJvcT1",
          "name": "scene_toledo_engineering",
          "title": "College of Engineering"
        }
      ]
    }
  },
  {
    "id": "way/423039652",
    "title": "Nitschke Hall",
    "campus": "Main",
    "popup": {
      "title": "Nitschke Hall",
      "content": null,
      "directions": {
        "lat": "41.655546123640505",
        "lng": " -83.606140948348"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": []
    }
  },
  {
    "id": "way/423039654",
    "title": "Nitschke Technology Complex",
    "campus": "Main",
    "popup": {
      "title": "Nitschke Technology Complex",
      "content": null,
      "directions": {
        "lat": "41.654299413507594",
        "lng": " -83.60614027031053"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": []
    }
  },
  {
    "id": "way/439090120",
    "title": "Ottawa House",
    "campus": "Main",
    "popup": {
      "title": "Ottawa House",
      "content": null,
      "directions": {
        "lat": "41.65473042345208",
        "lng": " -83.6161224020611"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": [
        {
          "id": "recgwgt8HPd63fWim",
          "name": "scene_toledo_dorm_lobby_1",
          "title": "Ottawa West Residence Hall Lobby"
        }
      ]
    }
  },
  {
    "id": "way/343961999",
    "title": "Ottawa House West",
    "campus": "Main",
    "popup": {
      "title": "Ottawa House West",
      "content": null,
      "directions": null,
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": [
        {
          "id": "recgwgt8HPd63fWim",
          "name": "scene_toledo_dorm_lobby_1",
          "title": "Ottawa West Residence Hall Lobby"
        }
      ]
    }
  },
  {
    "id": "way/313487906",
    "title": "Center for Performing Arts",
    "campus": "Main",
    "popup": {
      "title": "Center for Performing Arts",
      "content": "\n",
      "directions": {
        "lat": "41.658718149150005",
        "lng": " -83.6186305707613"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": [
        {
          "id": "recuhTeKQWhheXIuo",
          "name": "scene_toledo_perfoming_arts_theater",
          "title": "Center for Performing Arts Recital Hall"
        }
      ]
    }
  },
  {
    "id": "way/423039656",
    "title": "Palmer Hall",
    "campus": "Main",
    "hidden": true,
    "popup": {
      "title": "Palmer Hall",
      "content": null,
      "directions": {
        "lat": "41.65575198928555",
        "lng": " -83.60731304144585"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": []
    }
  },
  {
    "id": "way/431588208",
    "title": "Plant Operations",
    "campus": "Main",
    "hidden": true,
    "popup": {
      "title": "Plant Operations",
      "content": null,
      "directions": {
        "lat": "41.653860931936585",
        "lng": " -83.61240591428071"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": []
    }
  },
  {
    "id": "way/343961996",
    "title": "Presidents Hall",
    "campus": "Main",
    "popup": {
      "title": "Presidents Hall",
      "content": null,
      "directions": {
        "lat": "41.653870052146125",
        "lng": " -83.61725826661998"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": []
    }
  },
  {
    "id": "way/298027045",
    "title": "Parks Tower",
    "campus": "Main",
    "popup": {
      "title": "Parks Tower",
      "content": "\n",
      "directions": {
        "lat": "41.65730855109782",
        "lng": " -83.61565183907669"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": [
        {
          "id": "recxMm2maOI37up00",
          "name": "scene_toledo_dorm_lobby_2",
          "title": "Parks Tower Residence Hall Lobby"
        }
      ]
    }
  },
  {
    "id": "way/423039655",
    "title": "Research & Technology Complex 1",
    "campus": "Main",
    "popup": null
  },
  {
    "id": "way/112574121",
    "title": "Student Recreation Center",
    "campus": "Main",
    "popup": {
      "title": "Student Recreation Center",
      "content": null,
      "directions": {
        "lat": "41.65675920540614",
        "lng": " -83.61164422953219"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": [
        {
          "id": "recstp3y9FZXTc1M4",
          "name": "scene_toledo_fitness_center",
          "title": "Recreation Center"
        },
        {
          "id": "recuQjC29YwN3UdBV",
          "name": "scene_toledo_natatorium",
          "title": "Aquatic Center"
        }
      ]
    }
  },
  {
    "id": "way/261319322",
    "title": "Rocket Hall",
    "campus": "Main",
    "popup": {
      "title": "Rocket Hall",
      "content": "\n",
      "directions": {
        "lat": "41.654855989228444",
        "lng": " -83.61963207340544"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": [
        {
          "id": "recA9wOyQQRLCaLoU",
          "name": "scene_toledo_production_studio",
          "title": "Rocket Hall Production Studio"
        }
      ]
    }
  },
  {
    "id": "way/197291116",
    "title": "Ritter Astrophysical Research Center",
    "campus": "Main",
    "popup": {
      "title": "Ritter Astrophysical Research Center",
      "content": "\n",
      "directions": {
        "lat": "41.66230229383258",
        "lng": " -83.61223825349191"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": [
        {
          "id": "recWelYwt8QBCJZWp",
          "name": "scene_toledo_planetarium",
          "title": "Ritter Planetarium"
        }
      ]
    }
  },
  {
    "id": "way/227496383",
    "title": "Savage Business Complex",
    "campus": "Main",
    "popup": {
      "title": "Savage Business Complex",
      "content": "\n",
      "directions": {
        "lat": "41.662210184598614",
        "lng": " -83.61254491300225"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": [
        {
          "id": "recATC58ZdbDw5vDK",
          "name": "scene_toledo_finance",
          "title": "Neff Trading Room"
        }
      ]
    }
  },
  {
    "id": "way/635855257",
    "title": "Scott Hall",
    "campus": "Main",
    "popup": {
      "title": "Scott Hall",
      "content": null,
      "directions": {
        "lat": "41.66275569470968",
        "lng": " -83.61709189576197"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": []
    }
  },
  {
    "id": "way/112574116",
    "title": "Sullivan Hall",
    "campus": "Main",
    "hidden": true,
    "popup": {
      "title": "Sullivan Hall",
      "content": null,
      "directions": {
        "lat": "41.65729384761878",
        "lng": " -83.61742384792568"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": []
    }
  },
  {
    "id": "way/174807699",
    "title": "Snyder Memorial",
    "campus": "Main",
    "popup": {
      "title": "Snyder Memorial",
      "content": "\n",
      "directions": {
        "lat": "41.66062131324234",
        "lng": " -83.61309963510578"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": []
    }
  },
  {
    "id": "way/227496375",
    "title": "Stranahan Hall",
    "campus": "Main",
    "popup": {
      "title": "Stranahan Hall",
      "content": null,
      "directions": {
        "lat": "41.6619470672288",
        "lng": " -83.61264074939349"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": []
    }
  },
  {
    "id": "way/227598618",
    "title": "Student Union",
    "campus": "Main",
    "popup": {
      "title": "Student Union",
      "content": "\n",
      "directions": {
        "lat": "41.66054648895679",
        "lng": " -83.61467790071345"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": [
        {
          "id": "rectnd42hJboiGZW7",
          "name": "scene_toledo_student_union",
          "title": "Student Union"
        },
        {
          "id": "reciD5syOo5z3lcky",
          "name": "scene_toledo_student_services",
          "title": "Center for Advocacy and Student Experience"
        }
      ]
    }
  },
  {
    "id": "way/112574115",
    "title": "Savage Arena, John F.",
    "campus": "Main",
    "popup": {
      "title": "Savage Arena, John F.",
      "content": "\n",
      "directions": {
        "lat": "41.66007247731871",
        "lng": " -83.60990586439658"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": [
        {
          "id": "rechJostt6pouYcxp",
          "name": "scene_toledo_gym",
          "title": "Savage Arena"
        }
      ]
    }
  },
  {
    "id": "way/635855260",
    "title": "Tucker Hall",
    "campus": "Main",
    "popup": {
      "title": "Tucker Hall",
      "content": null,
      "directions": {
        "lat": "41.66190400579409",
        "lng": " -83.6170689663569"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": []
    }
  },
  {
    "id": "way/112574104",
    "title": "University Computer Center",
    "campus": "Main",
    "hidden": true,
    "popup": {
      "title": "University Computer Center",
      "content": null,
      "directions": {
        "lat": "41.65621784556442",
        "lng": " -83.60969793948094"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": []
    }
  },
  {
    "id": "relation/8833546",
    "title": "University Hall",
    "campus": "Main",
    "popup": {
      "title": "University Hall",
      "content": "University Hall was the first building built on the Bancroft Campus. It took 900 workers 11 months to construct the building. It was built in the Collegiate Gothic style and completed in 1931. It is one of the most recognizable buildings in the city and a source of pride for Toledo.\n",
      "directions": {
        "lat": "41.66216703426904",
        "lng": " -83.61437507685872"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": []
    }
  },
  {
    "id": "way/431588243",
    "title": "University Recycling",
    "campus": "Main",
    "hidden": true,
    "popup": null
  },
  {
    "id": "way/439633903",
    "title": "Wolfe Hall",
    "campus": "Main",
    "popup": {
      "title": "Wolfe Hall",
      "content": "\n",
      "directions": {
        "lat": "41.65979193941986",
        "lng": " -83.61762118796915"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": []
    }
  },
  {
    "id": "way/439090128",
    "title": "University Health Center",
    "campus": "Main",
    "popup": {
      "title": "University Health Center",
      "content": "\n",
      "directions": null,
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": []
    }
  },
  {
    "id": "way/673552849",
    "title": "McComas Village",
    "campus": "Main",
    "popup": {
      "title": "McComas Village",
      "content": "\n",
      "directions": null,
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": [
        {
          "id": "recCV4USGNWh77y6Q",
          "name": "scene_toledo_greek",
          "title": "McComas Village"
        }
      ]
    }
  },
  {
    "id": "way/438932100",
    "title": "Campus View Apartments",
    "campus": "Main",
    "hidden": true,
    "popup": null
  },
  {
    "id": "way/438927282",
    "title": "Gateway",
    "campus": "Main",
    "popup": null
  },
  {
    "id": "relation/9818511",
    "title": "Ruppert Health Center",
    "campus": "Health",
    "hidden": true,
    "popup": null
  },
  {
    "id": "way/705875456",
    "title": "Kobacker Center, Lenore W. & Marvin S.",
    "campus": "Health",
    "hidden": true,
    "popup": null
  },
  {
    "id": "way/706220172",
    "title": "Center for Creative Education",
    "campus": "Health",
    "popup": {
      "title": "Center for Creative Education",
      "content": null,
      "directions": {
        "lat": "41.6182802677747",
        "lng": " -83.61452329067181"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": [
        {
          "id": "recejBzAGcJLu18ja",
          "name": "scene_toledo_health_sciences_lobby",
          "title": "Interprofessional Immersive Simulation Center Lobby"
        },
        {
          "id": "recL3c0St150YJXmV",
          "name": "scene_toledo_health_sciences_sim_lab",
          "title": "Interprofessional Immersive Simulation Center Control Room"
        },
        {
          "id": "recSH7QV66UADMMjb",
          "title": "College of Nursing Simulation Lab"
        }
      ]
    }
  },
  {
    "id": "way/706217322",
    "title": "Collier Building, Howard L.",
    "campus": "Health",
    "popup": {
      "title": "Collier Building, Howard L.",
      "content": null,
      "directions": {
        "lat": "41.61922107586949",
        "lng": " -83.61393168630302"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": []
    }
  },
  {
    "id": "way/706244128",
    "title": "Mulford Library Building, Raymon H.",
    "campus": "Health",
    "popup": {
      "title": "Mulford Library Building, Raymon H.",
      "content": null,
      "directions": {
        "lat": "41.61990467807835",
        "lng": " -83.61546723782686"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": [
        {
          "id": "reckiHsdmcwWyGOtH",
          "name": "scene_toledo_health_sciences_library",
          "title": "Mulford Library"
        }
      ]
    }
  },
  {
    "id": "way/706242351",
    "title": "University Medical Center (Hospital)",
    "campus": "Health",
    "popup": {
      "title": "University Medical Center (Hospital)",
      "content": null,
      "directions": {
        "lat": "41.620523881576254",
        "lng": " -83.61639177959617"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": []
    }
  },
  {
    "id": "way/706229494",
    "title": "George Isaac Hall",
    "campus": "Health",
    "popup": {
      "title": "George Isaac Hall",
      "content": null,
      "directions": {
        "lat": "41.61952367156207",
        "lng": " -83.61771036473395"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": []
    }
  },
  {
    "id": "way/706229493",
    "title": "Dowling Hall, Ida Marie",
    "campus": "Health",
    "popup": {
      "title": "Dowling Hall, Ida Marie",
      "content": null,
      "directions": {
        "lat": "41.619233274945195",
        "lng": " -83.61764333311253"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": []
    }
  },
  {
    "id": "way/706228561",
    "title": "Medical Pavilion",
    "campus": "Health",
    "popup": {
      "title": "Medical Pavilion",
      "content": null,
      "directions": {
        "lat": "41.61864547460953",
        "lng": " -83.61758673991271"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": []
    }
  },
  {
    "id": "way/706228247",
    "title": "Orthopedic Center",
    "campus": "Health",
    "popup": {
      "title": "Orthopedic Center",
      "content": null,
      "directions": {
        "lat": "41.618563391935886",
        "lng": " -83.61779824118788"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": []
    }
  },
  {
    "id": "way/706226876",
    "title": "Health Education Center",
    "campus": "Health",
    "popup": {
      "title": "Health Education Center",
      "content": "\n",
      "directions": {
        "lat": "41.61854249756786",
        "lng": " -83.6163084720435"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": []
    }
  },
  {
    "id": "way/706222065",
    "title": "Wolfe Center, Thomas F. & Jeri S.",
    "campus": "Health",
    "popup": {
      "title": "Wolfe Center, Thomas F. & Jeri S.",
      "content": null,
      "directions": {
        "lat": "41.61868731054142",
        "lng": " -83.61550081335218"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": [
        {
          "id": "rec3YV7OMQOAtf3wn",
          "name": "scene_toledo_cosmo",
          "title": "Cosmetic Science Lab"
        }
      ]
    }
  },
  {
    "id": "way/706221646",
    "title": "Health Science Building, Paul J. Block Jr.",
    "campus": "Health",
    "popup": {
      "title": "Health Science Building, Paul J. Block Jr.",
      "content": null,
      "directions": {
        "lat": "41.61870203434595",
        "lng": " -83.61489670955304"
      },
      "driveLocation": null,
      "walkLocation": null,
      "linkedscenes": []
    }
  }
] }